import { render, staticRenderFns } from "./applyResult.vue?vue&type=template&id=bc2e06ac&scoped=true&"
import script from "./applyResult.vue?vue&type=script&lang=js&"
export * from "./applyResult.vue?vue&type=script&lang=js&"
import style0 from "./applyResult.vue?vue&type=style&index=0&id=bc2e06ac&lang=stylus&scoped=true&"
import style1 from "./applyResult.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e06ac",
  null
  
)

export default component.exports